(() => {
  const topicLabels = {
    'history-culture': '歴史や文化の匂い',
    'life-industry': '昔の暮らしや産業の匂い',
    'nature-material': '植物、海、森、土、木、煙',
    food: '食べ物の匂い',
    'story-art': '物語や作品世界の匂い',
    'lost-distinctive': '現在は存在しない匂い・特徴的な臭い',
  };

  document.querySelectorAll('[data-kyara-inquiry]').forEach((section) => {
    const bodyField = section.querySelector('[data-kyara-topic-body]');
    const topicField = section.querySelector('[data-kyara-topic-field]');

    section.querySelectorAll('[data-kyara-topic]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const topicLabel = topicLabels[link.dataset.kyaraTopic];
        const targetId = link.getAttribute('href')?.slice(1);

        if (!topicLabel || !bodyField || !topicField) return;

        event.preventDefault();
        const currentMessage = bodyField.value.replace(/^相談テーマ：.*\n\n/, '');
        bodyField.value = `相談テーマ：${topicLabel}\n\n${currentMessage}`;
        topicField.value = topicLabel;

        const target = targetId ? document.getElementById(targetId) : null;
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', `#${targetId}`);
        bodyField.focus({ preventScroll: true });
      });
    });
  });
})();
